import { SeatsChartChangePreviewTicket } from 'services/Seats';

const CSV_HEADERS = [
	'ticket_id',
	'seat_label',
	'status',
	'original_ticket_type_id',
	'original_ticket_type_name',
	'original_category_key',
	'new_ticket_type_id',
	'new_ticket_type_name',
	'new_category_key',
	'new_category_label',
];

const csvCell = (value: string | number | undefined | null): string => {
	if (value === undefined || value === null) return '';
	const str = String(value);
	return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export const buildChartChangeCsv = (tickets: SeatsChartChangePreviewTicket[]): string => {
	const rows = tickets.map((t) =>
		[
			t.ticket_id,
			t.seat_label,
			t.status,
			t.original_ticket_type_id,
			t.original_ticket_type_name,
			t.original_category_key,
			t.new_ticket_type_id,
			t.new_ticket_type_name,
			t.new_category_key,
			t.new_category_label,
		]
			.map(csvCell)
			.join(',')
	);
	return [CSV_HEADERS.join(','), ...rows].join('\n');
};

export const downloadChartChangeCsv = (filename: string, csv: string) => {
	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
};

export const chartChangeCsvQueryKey = (eventId: string, newChartKey: string) =>
	['seats-chart-change-preview', eventId, newChartKey] as const;
